import React from 'react';

import CustomExportDateTimeFilterDropdown from './CustomExportDateTimeFilterDropdown';
import CustomExportGeneralFilterDropdown from './CustomExportGeneralFilterDropdown';
import CustomExportNumberFilterDropdown from './CustomExportNumberFilterDropdown';

export function renderCustomExportNumberFilterDropdown(props) {
  return <CustomExportNumberFilterDropdown {...props} />;
}

export function renderCustomExportGeneralFilterDropdown(props) {
  return <CustomExportGeneralFilterDropdown {...props} />;
}

export function renderCustomExportTextFilterDropdown(props) {
  return <CustomExportGeneralFilterDropdown {...props} isText />;
}

export function renderCustomExportDateTimeFilterDropdown(col, dateOnly) {
  return (props) => (
    <CustomExportDateTimeFilterDropdown
      {...props}
      col={col}
      dateOnly={dateOnly}
    />
  );
}
